export const USER_PAGE_DUPLICATE_USERNAMES = 'Tried to visit user page with duplicate usernames'; // params: username
export const ERROR_CREATING_GROUP_IN_ONBOARDING = 'Error creating group in onboarding'; // params: userId, error
